<app-create-app #createApp  [domain]="payitem.sub_domain"></app-create-app>

<div class="p-3">

        <div class="modal-header">
            <h5 class="modal-title" >{{payitem.sub_domain}}.menuload.com</h5>
            <!-- <button type="button" class="btn-close" (click)="closePeyModal()"></button> -->
          </div>
          
        <div class="modal-body">

            <div class="row mb-3" *ngIf="payitem?.create">
                <div class="d-flex justify-content-center">
                <div class="form-check">
                    <input class="form-check-input d-none" type="radio" [(ngModel)]="business_type" id="restaurant" value="restaurant">
                    <label 
                    class="form-check-label" 
                    (ngModelChange)="'restaurant'"
                    [ngClass]="{'form-check-label-active': business_type === 'restaurant'}"
                    for="restaurant">
                        რესტორანი
                    </label>
                </div>
                
                <div class="form-check">
                    <input class="form-check-input d-none" type="radio" [(ngModel)]="business_type" id="hotel" value="hotel">
                    <label 
                    class="form-check-label mx-2" 
                    (ngModelChange)="'hotel'"
                    [ngClass]="{'form-check-label-active': business_type === 'hotel'}"
                    for="hotel">
                        სასტუმრო
                    </label>
                </div>
                </div>
            </div>
            <div class="row">
                <!-- Minimal Package -->
                <div class="col-md-6">
                    <div class="card border-0" 
                        [ngClass]="{'bg-success' : payitem.package === 'minimal'}"  
                        (click)="changePackage('minimal')">
                    <div class="pricing-card pricing-card-left">
                        <div class="pricing-header d-flex justify-content-between align-items-center">
                        <span>Minimal</span>
                        <button type="button" class="btn arrow-toggle" (click)="toggleCollapse('minimal'); $event.stopPropagation()">
                            <i class="fi fi-br-angle-down" 
                            [ngClass]="{'rotate': !isMinimalCollapsed}"></i>
                        </button>
                        </div>
                        <div class="price">
                        <span class="old-price">$25</span>
                        <span class="new-price">$20/mo</span>
                        </div>
                        <ul class="checklist mt-3 mb-4" *ngIf="!isMinimalCollapsed">
                        <li><i class="fi fi-br-check"></i> პროდუქტების შეუზღუდავი რაოდენობა</li>
                        <li><i class="fi fi-br-check"></i> მრავალენოვანი მენიუ</li>
                        <li><i class="fi fi-br-check"></i> მენიუს რედაქტირების პანელი</li>
                        <li><i class="fi fi-br-check"></i> შეფასებების მიღების შესაძლებლობა</li>
                        <li><i class="fi fi-br-check"></i> ანალიტიკის ფუნქცია</li>
                        <li><i class="fi fi-br-check"></i> ტექნიკური მხარდაჭერა</li>
                        </ul>
                    </div>
                    </div>
                </div>

                <!-- Pro Package -->
                <div class="col-md-6">
                    <div class="card border-0" 
                        [ngClass]="{'bg-success' : payitem.package === 'pro'}"  
                        (click)="changePackage('pro')">
                    <div class="pricing-card pricing-card-right">
                        <div class="pricing-header d-flex justify-content-between align-items-center">
                        <span>Pro</span>
                        <button type="button" class="btn arrow-toggle" (click)="toggleCollapse('pro'); $event.stopPropagation()">
                            <i class="fi fi-br-angle-down"
                            [ngClass]="{'rotate': !isProCollapsed}"></i>
                        </button>
                        </div>
                        <div class="price">
                        <span class="old-price">$45</span>
                        <span class="new-price">$40/mo</span>
                        </div>
                        <ul class="checklist mt-3 mb-4" *ngIf="!isProCollapsed">
                        <li><i class="fi fi-br-check"></i> პროდუქტების შეუზღუდავი რაოდენობა</li>
                        <li><i class="fi fi-br-check"></i> მრავალენოვანი მენიუ</li>
                        <li><i class="fi fi-br-check"></i> მენიუს რედაქტირების პანელი</li>
                        <li><i class="fi fi-br-check"></i> შეფასებების მიღების შესაძლებლობა</li>
                        <li><i class="fi fi-br-check"></i> qr code დანომრვა მაგიდების</li>
                        <li><i class="fi fi-br-check"></i> მაგიდიდან შეკვეთა</li>
                        <li><i class="fi fi-br-check"></i> ვებგვერდი მიტანის/წაღებისა და რეზერვაციის ფუნქციით</li>
                        <li><i class="fi fi-br-check"></i> შეკვეთთების სტატუსის კონტროლი</li>
                        <li><i class="fi fi-br-check"></i> ანალიტიკის ფუნქცია</li>
                        <li><i class="fi fi-br-check"></i> ტექნიკური მხარდაჭერა</li>
                        </ul>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-3">
            <label for="monthSelect">აირჩიეთ თვეების რაოდენობა:</label>
            <select id="monthSelect" class="form-select"
                    [(ngModel)]="selectedMonths" 
                    (change)="calculatePrice()">
                <option *ngFor="let month of monthsOptions" [value]="month">{{ month }} თვე</option>
            </select>
        
            <div class="mt-3">
                <!-- <h2 class="text-success">გადასახდელი თანხა: <strong>{{ totalPrice }} ₾</strong></h2> -->
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn btn-danger" (click)="pey(payitem)">
                <span *ngIf="!loadPay">
                    გადახდა  
                   <strong>{{ totalPrice }} $</strong> 
                </span>
                <span *ngIf="loadPay" class="spinner-border spinner-border-sm" role="status" ></span>
            </button>
        </div>

    </div>